"use client";

import Button from "@/components/atoms/Button";
import { getPreviousApplication } from "@/helpers/cookies";
import { generateApplyToAJobUrl } from "@/helpers/url";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface ApplyButtonProps {
  job: {
    id: string;
    office_id: string | null;
    sector_group: string | null;
    title: string;
  };
  locale: AllowedLanguages;
}

export const ApplyButton = ({ job, locale }: ApplyButtonProps) => {
  const { t } = useTranslation(locale);
  const previousApplication = getPreviousApplication(job.id);

  const dataLayerScript = `
      dataLayer.push({
        "event": "ecommerce",
        "eventCategory": "ecommerce",
        "eventAction": "start application",
        "eventLabel": "${job.id}",
        "ecommerce": {
          "add": {
            "products": [
              {
                "name": "${job.title}",
                "id": "${job.id}",
                "price": "10",
                "brand": "${job.office_id}",
                "category": "${job.sector_group}",
                "quantity": 1
              }
            ]
          }
        }
      });
    `;

  const handleApplyButtonClick = () => {
    const script = document.createElement("script");
    script.text = dataLayerScript;
    document.head.appendChild(script);
  };

  return (
    <>
      {previousApplication ? (
        <Button
          as="link"
          href={`/${locale}/myvivaldis`}
          className="btn-lg btn-outline w-full sm:w-auto"
        >
          {t("pages.job.btn.check_application_status")}
        </Button>
      ) : (
        <Button
          as="link"
          href={generateApplyToAJobUrl({ locale, jobId: job.id })}
          className="btn-lg w-full sm:w-auto"
          onClick={() => {
            handleApplyButtonClick();
          }}
        >
          {t("pages.job.btn.apply")}
        </Button>
      )}
    </>
  );
};

export default ApplyButton;
